<template>
	<div>
		<div v-if="manage === true" class="data-title">
			<div class="title-cell">
				<div class="title">Custom Filter Rule(s)</div>
			</div>
			<div class="buttons">
				<a href @click.prevent="openNewFilterModal" class="button"><div class="hover-title">Add Rule</div><span class="fa fa-plus"></span></a>
			</div>
		</div>
		<div v-else class="search-container">
			<a href @click.prevent="openNewFilterModal" class="search-icon"><div class="hover-title">Apply Filters</div><span class="fa fa-sliders-v"></span></a>
			<router-link :to="{ name: 'module-filters-page', params: $route.params }" exact class="search-icon"><div class="hover-title">My Filters</div><span class="fa fa-cog"></span></router-link>
			<slot></slot>
		</div>

		<div v-if="!manage && module.filters.length > 0" class="input-container">
			<div class="input-title">Quick Filters</div>
			<div class="big-buttons grid four">
				<a href v-for="filter in module.filters" :key="`quick-filter-${filter.id}`" @click.prevent="() => selectQuickFilter(filter)"><div>{{ filter.name }}</div></a>
			</div>
		</div>

		<nothing-here v-if="manage === true && listOptions.filters.length === 0"></nothing-here>

		<div v-if="loaded && hasFilters" class="search-results">
			<a href @click.prevent="reset" class="clear-button"><span class="fa fa-undo"></span>Clear Filters</a>
			<div class="title-cell">
				<div v-if="loadingState.state === 'LOADED' && filteredCount !== null" class="title">{{ filteredCount }} Filtered {{ filteredCount !== 1 ? 'Results' : 'Result' }}</div>
				<div v-if="listOptions.filters.length > 0" class="subtitle">
					<b>Advanced Filters Applied:</b>
					<ul>
						<li v-for="filter in listOptions.filters" :key="`list-filter-${filter.id}`"><a href @click.prevent="removeFilter(filter)" class="filter-button"><span class="fa fa-times-circle"></span></a><a href @click.prevent="editFilter(filter)" v-html="description(filter)"></a></li>
					</ul>
				</div>
				<!-- Nov 28 2021 - This is a state that can indicate we're updating the list, which would be needed if we keep showing previous results during async request -->
<!--				<div v-if="loadingState.state === 'LOADING' && loadingState.loadedOptions"><span class="fa fa-sync fa-spin"></span> Updating...</div>-->
			</div>
		</div>

		<loading v-if="manage && !loaded"></loading>

		<filter-modal
			v-if="addFilterModalOpen"
			:loading="loading"
			:relations="filterRelations"
			:filter="editingFilter"
			:module="module"
			@cancel="addFilterModalOpen = false"
			@submit="onAddFilter"
		></filter-modal>
	</div>
</template>

<script>

import _ from 'underscore';
import { mapGetters } from 'vuex';
import FilterModal from '@/views/sections/app/modules/components/filters/FilterModal';
import { filterDescription } from '@/views/sections/app/modules/components/filters/filter-description';

export default {

	props: [ 'module', 'manage', 'value', 'loadingState', 'hasFilters', 'filteredCount' ],

	data() {
		return {
			loaded: false,
			loading: false,
			filterRelations: null,
			addFilterModalOpen: false,
			listOptions: this.value,
			editingFilter: null,
		};
	},

	watch: {
		value: function(newValue) {
			this.listOptions = newValue;
		},
	},

	computed: mapGetters(['currentAccount']),

	mounted() {
		if (this.manage) {
			this.loadFilterData();
		}
	},

	methods: {

		openNewFilterModal() {
			// If needed: load tags & associated module data
			this.loadFilterData();
			this.editingFilter = null;
			this.addFilterModalOpen = true;
		},

		async loadFilterData() {
			if (this.loaded || this.loading) return;

			this.loading = true;

			try {
				const { data } = await this.$api.get(`/module/${this.module.slug}/create`);
				this.filterRelations = data;
				this.loaded = true;
			} catch (e) {
				console.log('couldnlt load filter data',  e.message);
			}

			this.loading = false;
		},

		selectQuickFilter(filter) {
			this.$set(this.listOptions, 'filters', filter.filters);
			if (!this.loaded && !this.loading) {
				this.loadFilterData();
			}
		},

		editFilter(filter) {
			this.editingFilter = _.clone(filter);
			this.addFilterModalOpen = true;
		},

		onAddFilter(filter) {
			let index = _.findIndex(this.listOptions.filters, ({id}) => id === filter.id);
			if (index !== -1) {
				this.$set(this.listOptions.filters, index, filter);
			} else {
				this.listOptions.filters.push(filter);
			}

			this.emit();
		},

		description(filter) {
			return filterDescription(this.module, filter, this.filterRelations, true);
		},

		removeFilter(filter) {
			this.listOptions.filters = this.listOptions.filters.filter(({id}) => id !== filter.id);
			this.emit();
		},

		reset() {
			this.$set(this.listOptions, 'filters', []);
			this.$set(this.listOptions, 'searchTerm', '');
			this.emit();
		},

		emit() {
			this.addFilterModalOpen = false;
			this.editingFilter = null;
			this.$emit('input', this.listOptions);
		},

	},

	components: {
		FilterModal,
	},
};

</script>
